import React, { useEffect, useMemo } from "react";
import { useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useCall } from "../../call-sdk/context/CallContext";
import Config from "../../config";
import { useRoomContext } from "src/call-sdk/context/RoomContext";
import StorageConstants from "src/config/storage.constants";
import LocalStorage from "src/call-sdk/lib/local-storage";

// Define an interface for the styled component props
interface ContainerProps {
  isSmallScreenLaptop: boolean;
}

const HeaderContainer = styled("div")({
  flex: 1,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "fixed",
  top: "25px",
});

const Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  backgroundColor: "white",
}));

const Content = styled("div")<ContainerProps>(({ isSmallScreenLaptop }) => ({
  textAlign: isSmallScreenLaptop ? "center" : "left",
  fontFamily: "Source Sans Pro, sans-serif",
  position: "fixed",
  // top: "40vh",
}));

const Heading = styled("div")<ContainerProps>(({ isSmallScreenLaptop }) => ({
  color: "black",
  fontSize: isSmallScreenLaptop ? "20px" : "32px",
  marginBottom: "10px",
  padding: "1rem",
}));

const BoldHeading = styled("div")`
  color: #111;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  padding-bottom: 8px;
`;

const MobileError = () => {
  const isSmallScreenLaptop = useMediaQuery("(max-width: 1024px)");
  const { error } = useCall();

  const { room } = useRoomContext();

  const isHUUser = Boolean(LocalStorage.get(StorageConstants.IS_HU_USER));

  //room get connected after few sec delay after cancel HU request, so disconnect if redirected to qr-error
  useEffect(() => {
    room?.disconnect();
  }, [room]);

  const { heading, content } = useMemo(() => {
    if (typeof error !== "string") {
      return { heading: "", content: "" };
    }
    const [heading, content] = error.split("|");
    return error.includes("|")
      ? { heading, content }
      : { heading: "", content: error };
  }, [error]);

  const regionConfig = Config[`${process.env.REACT_APP_REGION}`];

  return (
    <Container>
      <HeaderContainer id="header-container">
        <img
          src={regionConfig.appLogoImageSrc}
          alt="Convo Logo"
          id="logo-image"
          width="100%"
          height={regionConfig.appLogoImageHeight}
        />
      </HeaderContainer>
      <Content isSmallScreenLaptop={isSmallScreenLaptop}>
        <Heading
          isSmallScreenLaptop={isSmallScreenLaptop}
          id="error-heading"
          tabIndex={0}
        >
          {heading && <BoldHeading>{heading}</BoldHeading>}
          {content ||
            (isHUUser && "Session expired. Please scan the QR code again!") ||
            "Oops! Please try again later or feel free to reach out to your business partner for assistance."}
        </Heading>
      </Content>
    </Container>
  );
};

export default MobileError;
